import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Provider } from "mobx-react"
import { Icon } from 'antd'
import SingleEventCard from '../layoutComponents/SingleEventCard'
import CustomRouter from '../../stores/CustomRouter';
import NavViews from '../../stores/NavViews';
import LoadingCard from './LoadingCard';
import SingleEventPage from '../layoutComponents/SingleEventPage';
import NewEventPage from '../layoutComponents/NewEventPage';
@inject("AdminStore")
@observer(["web3Store", "eventStore", "WagerStore", "CustomRouter", "ViewStore", "CategoriesStore"])
class SingleEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            query: true,
            event: {}
        };
    }

    async componentWillMount() {
        const { CustomRouter } = this.props;
        const { router: { params } } = CustomRouter;
        const { eventStore } = this.props;
        const { WagerStore, AdminStore } = this.props;
        let self = this;

        eventStore.querySingleEvent(params.eventID).then(() => {
            this.setState({ event: eventStore.activeEvent, loading: false });
            let event = eventStore.activeEvent;
            AdminStore.setSingleEventView(true);
            let crumbs = `${new Date(this.props.eventStore.activeEvent.startTime * 1000).toLocaleDateString()} - ${new Date(this.props.eventStore.activeEvent.startTime * 1000).toLocaleTimeString()}`
            AdminStore.setEventCrumbs(crumbs);
        }
        );
       

        WagerStore.queryEventWagers(params.eventID).then(async () => {

        });

        this.props.ViewStore.changeCurrentPage('SingleEvent')
    }

    componentWillUnmount() {
        this.props.AdminStore.setSingleEventView(false);
        this.props.ViewStore.changePreviousPage('SingleEvent')
    }

    render() {
        const { eventStore } = this.props;
        const { WagerStore } = this.props;

        const { CustomRouter } = this.props;
        const { router: { params } } = CustomRouter;

        let event = eventStore.activeEvent;

        return (
            <Provider>
                <div>
                    {/* <button className="custom-btn-primary" style={{ margin: '0px 0px 15px 0px' }} onClick={() => CustomRouter.router.goTo(NavViews.home)}><Icon type="left" /> BACK</button> */}
                    {
                        this.state.loading ? <LoadingCard /> :
                            // <SingleEventCard
                            //     event={event}
                            //     key={event._id}
                            //     event_id={event._id}
                            //     bytes32_id={event.bytes32Id}
                            //     start_time={event.startTime}
                            //     duration={event.duration}
                            //     team_one={event.teams[0]}
                            //     team_two={event.teams[1]}
                            //     cancelled={event.cancelled}
                            //     finalized={event.finalized}
                            //     drawPossible={event.drawPossible}
                            //     teamOneColor={event.teamOneColor}
                            //     teamTwoColor={event.teamTwoColor}
                            //     betsForTeamOne={event.betsForTeamOne}
                            //     betsForTeamTwo={event.betsForTeamTwo}
                            //     amountBetForOne={event.amountBetForOne}
                            //     amountBetForTwo={event.amountBetForTwo}
                            //     teamOneColor={event.teamOneColor}
                            //     teamTwoColor={event.teamTwoColor}
                            //     teamOneWagers={WagerStore.teamOneWagers}
                            //     teamTwoWagers={WagerStore.teamTwoWagers}
                            //     isPropEvent={event.isPropEvent}
                            //     relatedPropEvents={event.relatedPropEvents}
                            //     drawWagers={WagerStore.drawWagers}
                            // />
                            <NewEventPage event={event} />
                    }
                </div>
            </Provider>
        );
    }
}

export default SingleEvent;


// WEBPACK FOOTER //
// ./src/components/appComponents/SingleEvent.js